import axiosInstance from '@api/axios-instance.ts';
import { OrganizationApiKeyModel } from '@models/organization.model.ts';

export const getOrganizationApiKey =
  async (): Promise<OrganizationApiKeyModel> => {
    const response = await axiosInstance.get<OrganizationApiKeyModel>(
      '/pms/organizations/api-token'
    );
    return response.data;
  };
